
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30371',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30371",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54706",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8066",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11524",
  "I18n": "static-7.1633",
  "quartz": "static-1.7092",
  "quartz-config": "static-1.870",
  "quartz-core": "static-1.6311",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.804",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54693",
  "feedback-utils": "static-1.54697",
  "forms-embed-utils-lib": "static-1.4514",
  "forms-utils-lib": "static-1.12674",
  "foundations-assets": "static-1.4920",
  "foundations-components": "static-1.8024",
  "foundations-theming": "static-1.4474",
  "hub-http": "static-1.6273",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11831",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3958",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16728",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5384",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57621",
  "transmute": "static-2.85",
  "ui-images": "static-2.1165",
  "UIComponents": "static-3.8470",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3440",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3369",
  "quartz-webpack": "static-1.3316",
  "foundations-theming-specialty": "static-1.2190",
  "property-description-translator": "static-1.3893",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3177",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4376",
  "jasmine-runner": "static-1.6514",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4691",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.767",
  "quartz-head": "static-1.757",
  "quartz-i18n": "static-1.767",
  "quartz-routing": "static-1.522",
  "quartz-test": "static-1.767",
  "quartz-tracking": "static-1.471",
  "ui-fonts": "static-1.786",
  "usage-tracker-container": "static-1.7390",
  "usage-tracker-core": "static-1.7250",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7299",
  "reference-resolvers": "static-1.8222",
  "sanitize-text": "static-1.8193",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10415",
  "sanitize": "static-1.4526",
  "outpost": "static-1.4227",
  "rpc-client-utils": "static-1.4703",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4293",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9474",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2071",
  "bend-plugin-foundations-theming": "static-1.2957",
  "foundations-theming-base": "static-1.3459",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.121",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9092",
  "atom": "static-1.5125",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7825",
  "ContentUtils": "static-1.68510",
  "data-token-picker": "static-1.16489",
  "file-manager-components": "static-1.23750",
  "FileManagerCore": "static-1.39249",
  "FileManagerLib": "static-1.39390",
  "frontend-preferences-client": "static-1.7977",
  "hub-http-contrib": "static-1.3092",
  "interframe": "static-3.4809",
  "layout-dnd-components": "static-1.12537",
  "layout-dnd-utils": "static-1.11512",
  "property-translator": "static-1.5449",
  "react-codemirror": "static-1.10678",
  "react-colorpicker": "static-2.10259",
  "reference-resolvers-lite": "static-1.8146",
  "rich-text-lib": "static-1.19914",
  "tinymce-data": "static-1.40592",
  "tinymce-themes": "static-1.56477",
  "ui-addon-emoji-picker": "static-1.9937",
  "ui-addon-sales-email": "static-1.5261",
  "ui-brand-identity-lib": "static-1.15472",
  "bender-build-tools": "static-1.3227",
  "hub-http-shared-msw-handlers": "static-1.10082",
  "hubspotter-http-shared-msw-handlers": "static-1.10080",
  "usage-tracker-session-replay": "static-1.5086",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.113",
  "chirp-fetch": "static-1.1938",
  "chatspot-core": "static-1.21505",
  "copilot-toolkit": "static-1.11263",
  "customer-data-objects-ui-components": "static-1.13081",
  "data-fetching-client": "static-1.9715",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4810",
  "ui-addon-video-player": "static-1.8754",
  "ui-coaching-tips": "static-1.28698",
  "usage-tracker": "static-1.7400",
  "cms-field-types": "static-1.4863",
  "content-icons-ui": "static-1.2239",
  "integrations-lib": "static-1.16320",
  "customer-data-objects": "static-1.7726",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4702",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4204",
  "ui-addon-iframeable": "static-1.9110",
  "video-components-external": "static-1.11454",
  "video-data-lib": "static-1.35112",
  "audio-components": "static-1.5988",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29385",
  "FileManagerImages": "static-1.36901",
  "foundations-components-legacy": "static-1.1049",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9038",
  "urlinator": "static-1.4588",
  "video-components": "static-1.13456",
  "video-embed": "static-1.35946",
  "ts-schema": "static-1.4120",
  "ContentData": "static-1.68585",
  "layout-data-lib": "static-1.9837",
  "react-dnd-compat": "static-1.4664",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1592",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6938",
  "hs-promise-utils": "static-1.5641",
  "inbound-db-properties-service-client": "static-1.3886",
  "NamespacedHubStyle": "static-2.9099",
  "growth-onboarding-confetti": "static-1.3117",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11202",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.826",
  "magpie-lib": "static-1.5583",
  "magpie-types": "static-1.5043",
  "simple-logging-lib": "static-1.3101",
  "avatar-components": "static-1.2549",
  "customer-data-ui-utilities": "static-1.9876",
  "growth-onboarding-feedback-components": "static-1.6630",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4928",
  "integrations-error-boundary-lib": "static-1.13735",
  "integrations-tracking-lib": "static-1.5653",
  "laboratory-lib": "static-3.7206",
  "native-integrations-shared-strings": "static-1.7832",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10260",
  "unified-auth": "static-1.552",
  "navigation-messaging": "static-1.7488",
  "content-media-composition-data-lib": "static-1.12517",
  "content-media-compositions": "static-2.16524",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19013",
  "unified-auth-core-lib": "static-1.834",
  "social-insights-client-types": "static-1.22235",
  "advanced-menus-core": "static-1.15203",
  "advanced-menus-lib": "static-1.12140",
  "ExportDialog": "static-6.10436",
  "ui-memberships-settings-lib": "static-1.34181",
  "conditional-properties-service-client": "static-1.3838",
  "crm-pipelines-api-client-types": "static-1.4180",
  "fdsr-migration-layer": "static-1.57",
  "framework-builder-read-service-client": "static-1.4045",
  "framework-data-schema-quick-fetch": "static-1.6843",
  "inbound-db-meta-service-client": "static-1.3626",
  "multi-currency-client-types": "static-1.3732",
  "persist-promise": "static-1.3749",
  "foundations-components-test-utils": "static-1.5507",
  "breeze-engine-core": "static-1.104",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.774",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.387",
  "universal-page-editor-lib": "static-1.3066",
  "google-sheets-integration-lib": "static-1.381",
  "microsoft-drive-integration-lib": "static-1.513",
  "slack-ui-library": "static-1.10442",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3781",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15202",
  "simple-menus-lib": "static-1.16719",
  "crm-record-cards-service-types": "static-1.3630",
  "location-customization-utils-lib": "static-1.9405",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30371",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54706",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8066",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11524",
  "I18n": "/I18n/static-7.1633",
  "quartz": "/quartz/static-1.7092",
  "quartz-config": "/quartz-config/static-1.870",
  "quartz-core": "/quartz-core/static-1.6311",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.804",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54693",
  "feedback-utils": "/feedback-utils/static-1.54697",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4514",
  "forms-utils-lib": "/forms-utils-lib/static-1.12674",
  "foundations-assets": "/foundations-assets/static-1.4920",
  "foundations-components": "/foundations-components/static-1.8024",
  "foundations-theming": "/foundations-theming/static-1.4474",
  "hub-http": "/hub-http/static-1.6273",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11831",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16728",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5384",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57621",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1165",
  "UIComponents": "/UIComponents/static-3.8470",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3369",
  "quartz-webpack": "/quartz-webpack/static-1.3316",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2190",
  "property-description-translator": "/property-description-translator/static-1.3893",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3177",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4376",
  "jasmine-runner": "/jasmine-runner/static-1.6514",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.767",
  "quartz-head": "/quartz-head/static-1.757",
  "quartz-i18n": "/quartz-i18n/static-1.767",
  "quartz-routing": "/quartz-routing/static-1.522",
  "quartz-test": "/quartz-test/static-1.767",
  "quartz-tracking": "/quartz-tracking/static-1.471",
  "ui-fonts": "/ui-fonts/static-1.786",
  "usage-tracker-container": "/usage-tracker-container/static-1.7390",
  "usage-tracker-core": "/usage-tracker-core/static-1.7250",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7299",
  "reference-resolvers": "/reference-resolvers/static-1.8222",
  "sanitize-text": "/sanitize-text/static-1.8193",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10415",
  "sanitize": "/sanitize/static-1.4526",
  "outpost": "/outpost/static-1.4227",
  "rpc-client-utils": "/rpc-client-utils/static-1.4703",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4293",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9474",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2071",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2957",
  "foundations-theming-base": "/foundations-theming-base/static-1.3459",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9092",
  "atom": "/atom/static-1.5125",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7825",
  "ContentUtils": "/ContentUtils/static-1.68510",
  "data-token-picker": "/data-token-picker/static-1.16489",
  "file-manager-components": "/file-manager-components/static-1.23750",
  "FileManagerCore": "/FileManagerCore/static-1.39249",
  "FileManagerLib": "/FileManagerLib/static-1.39390",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7977",
  "hub-http-contrib": "/hub-http-contrib/static-1.3092",
  "interframe": "/interframe/static-3.4809",
  "layout-dnd-components": "/layout-dnd-components/static-1.12537",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11512",
  "property-translator": "/property-translator/static-1.5449",
  "react-codemirror": "/react-codemirror/static-1.10678",
  "react-colorpicker": "/react-colorpicker/static-2.10259",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8146",
  "rich-text-lib": "/rich-text-lib/static-1.19914",
  "tinymce-data": "/tinymce-data/static-1.40592",
  "tinymce-themes": "/tinymce-themes/static-1.56477",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9937",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5261",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15472",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10082",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10080",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5086",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.113",
  "chirp-fetch": "/chirp-fetch/static-1.1938",
  "chatspot-core": "/chatspot-core/static-1.21505",
  "copilot-toolkit": "/copilot-toolkit/static-1.11263",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13081",
  "data-fetching-client": "/data-fetching-client/static-1.9715",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4810",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8754",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28698",
  "usage-tracker": "/usage-tracker/static-1.7400",
  "cms-field-types": "/cms-field-types/static-1.4863",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "integrations-lib": "/integrations-lib/static-1.16320",
  "customer-data-objects": "/customer-data-objects/static-1.7726",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4702",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4204",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9110",
  "video-components-external": "/video-components-external/static-1.11454",
  "video-data-lib": "/video-data-lib/static-1.35112",
  "audio-components": "/audio-components/static-1.5988",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29385",
  "FileManagerImages": "/FileManagerImages/static-1.36901",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1049",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9038",
  "urlinator": "/urlinator/static-1.4588",
  "video-components": "/video-components/static-1.13456",
  "video-embed": "/video-embed/static-1.35946",
  "ts-schema": "/ts-schema/static-1.4120",
  "ContentData": "/ContentData/static-1.68585",
  "layout-data-lib": "/layout-data-lib/static-1.9837",
  "react-dnd-compat": "/react-dnd-compat/static-1.4664",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1592",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6938",
  "hs-promise-utils": "/hs-promise-utils/static-1.5641",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3117",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11202",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.826",
  "magpie-lib": "/magpie-lib/static-1.5583",
  "magpie-types": "/magpie-types/static-1.5043",
  "simple-logging-lib": "/simple-logging-lib/static-1.3101",
  "avatar-components": "/avatar-components/static-1.2549",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9876",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6630",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4928",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13735",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5653",
  "laboratory-lib": "/laboratory-lib/static-3.7206",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7832",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10260",
  "unified-auth": "/unified-auth/static-1.552",
  "navigation-messaging": "/navigation-messaging/static-1.7488",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12517",
  "content-media-compositions": "/content-media-compositions/static-2.16524",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19013",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.834",
  "social-insights-client-types": "/social-insights-client-types/static-1.22235",
  "advanced-menus-core": "/advanced-menus-core/static-1.15203",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12140",
  "ExportDialog": "/ExportDialog/static-6.10436",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34181",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.57",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6843",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
  "persist-promise": "/persist-promise/static-1.3749",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5507",
  "breeze-engine-core": "/breeze-engine-core/static-1.104",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.774",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.387",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3066",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.381",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.513",
  "slack-ui-library": "/slack-ui-library/static-1.10442",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3781",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15202",
  "simple-menus-lib": "/simple-menus-lib/static-1.16719",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9405",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
